import styled from 'styled-components';
import { ThumbnailScroller } from 'styles';

export const Base = styled(ThumbnailScroller)`
	margin-top: 8px;
	margin-left: 4px;
	margin-right: 4px;
`;
